import { render, staticRenderFns } from "./GoToLegacy.vue?vue&type=template&id=4e2823ab&scoped=true&"
import script from "./GoToLegacy.vue?vue&type=script&lang=ts&"
export * from "./GoToLegacy.vue?vue&type=script&lang=ts&"
import style0 from "./GoToLegacy.vue?vue&type=style&index=0&id=4e2823ab&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2823ab",
  null
  
)

export default component.exports